import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';

import {
  analytics,
  // getSearchOpenDetail,
  getNavigationOpenDetail,
  getWhereToBuy,
  getClickSignUpCta,
  getClickPageBreadcrumbs,
} from '@/utils/analytics';

import { getContent } from '@/utils/helper';
import { useIsKorean } from '@/utils/useLocale';

import Icon from '@/atoms/Icon/Icon';
import Text from '@/atoms/Text/Text';
import Button from '@/atoms/Button/Button';
import DDLogo from '@/atoms/Logo/DDLogo';
import { CtaWrapper } from '@/molecules/CTA/index';
// import Search from '@/molecules/Search/Search';
import NavigationWithSubMenu from '@/molecules/NavigationWithSubMenu/NavigationWithSubMenu';

function NavigationSticky({ fields = [], entries = [], hasBackground = false, slug, hasBreadcrumbs }) {
  // const [searchIsOpen, setSearchIsOpen] = useState(false);
  const [navigationIsOpen, setNavigationIsOpen] = useState(false);
  const [showCta, setShowCta] = useState(true);
  const { asPath, locale, defaultLocale } = useRouter();
  const isKorean = useIsKorean();

  // Extract pathname without query parameters and hash
  const pathname = asPath.split('?')[0].split('#')[0];
  const breadcrumbs = pathname.split('/').filter(item => item !== "");

  const toggleNavigation = (e) => {
    if (!navigationIsOpen) {
      analytics({
        window,
        document,
        detail: getNavigationOpenDetail(e),
      });
      setNavigationIsOpen(true);
    } else {
      setNavigationIsOpen(false);
    }
  };

  const closeNavigation = () => setNavigationIsOpen(false);

  // const openSearch = (e) => {
  //   analytics({
  //     window,
  //     document,
  //     detail: getSearchOpenDetail(e),
  //   });
  //   setSearchIsOpen(true);
  // };

  const handleWhereToBuy = (e, { link_url, link_text, link_classes, lang_country }) => {
    analytics({
      window,
      document,
      detail: getWhereToBuy(e, {
        link_url,
        link_text,
        link_classes,
        lang_country,
      }),
    });
  };

  const handleSignUpCta = (e, { link_url, link_text, link_classes, lang_country }) => {
    analytics({
      window,
      document,
      detail: getClickSignUpCta(e, {
        link_url,
        link_text,
        link_classes,
        lang_country,
      }),
    });
    if (locale == defaultLocale) {
      window.location.href = `/${link_url}`;
    } else {
      window.location.href = `/${locale}/${link_url}`
    }
  };

  const handlePageBreadcrumbs = (e, { animation, link_url, link_text, link_classes, lang_country }) => {
    analytics({
      window,
      document,
      detail: getClickPageBreadcrumbs(e, {
        animation,
        link_url,
        link_text,
        link_classes,
        lang_country
      }),
    });
  };

  // useEffect(() => {
  //   if (searchIsOpen || navigationIsOpen) {
  //     document.body.style.overflow = 'hidden';
  //   } else {
  //     document.body.style.overflow = 'unset';
  //   }

  //   return () => (document.body.style.overflow = 'unset');
  // }, [searchIsOpen, navigationIsOpen]);

  const navigationMenu =
    fields?.links?.length > 0
      ? fields.links.map((link) => {
          const menuContent = getContent(link.sys.id, entries)?.fields;
          const subNavigationCtaContent = menuContent.subNavigationCta?.map((subNavigationCta) => {
            return getContent(subNavigationCta.sys.id, entries)?.fields;
          })
          const subNavigationContent = menuContent.subNavigation?.map((subNavigation) => {
            return getContent(subNavigation.sys.id, entries)?.fields;
          })

          // get page preview & url per link
          const page =
            menuContent?.pages && menuContent?.pages.length
              ? getContent(menuContent?.pages[0].sys.id, entries)
              : menuContent?.page
              ? getContent(menuContent?.page?.sys?.id, entries)
              : null;
          return {
            ...menuContent,
            subNavigationContent: {
              subNavigationStyle: menuContent.subNavigationStyle,
              subNavigationHeader: menuContent.subNavigationHeader,
              subNavigationCta: subNavigationCtaContent,
              subNavigation: subNavigationContent,
            },
            pageUrl: page?.fields?.slug,
            pageContent: {
              cloudinaryPreviewAssets: page?.fields?.cloudinaryPreviewAssets,
              previewAsset: page?.fields?.previewAsset,
              previewText: getContent(
                page?.fields?.previewText?.sys?.id,
                entries
              ),
            },
          };
        })
      : [];

  return (
    <>
      <div
        className={`sticky z-50 top-0 w-full h-[86px] lg:h-[100px] bg-white`}
        key={slug}
      >
        <div className="relative z-40">
          <nav id="navigation" className="nav-menu">
            <div className={`w-full pl-[27px] pr-[23px] lg:px-[30px] bg-progressive-blue`}>
              <div className="flex h-[86px] lg:h-[100px] lg:items-center lg:justify-center py-[10px]">
                <div className="nav-menu__logo cursor-pointer w-fit left-[27px] lg:absolute lg:left-[30px] lg:top-[20px]">
                  <CtaWrapper page="/">
                    <DDLogo width={51.05} height={60} />
                  </CtaWrapper>
                </div>
                <Button
                  invert={hasBackground}
                  style="lg:hidden nav-menu__btn cursor-pointer text-natural-cream w-fit absolute right-[23px] top-[30px]"
                  onClick={toggleNavigation}
                >
                  {navigationIsOpen ? (
                    <Icon name="close" height={24} width={24} />
                  ) : (
                    <Icon name="hamburger" height={24} width={24} />
                  )}
                </Button>
                <NavigationWithSubMenu
                  entries={entries}
                  navigationMenu={navigationMenu}
                  closeNavigation={closeNavigation}
                  style={`hidden lg:flex h-[60px]`}
                />
                <div className="nav-menu__actions hidden lg:flex justify-end items-center gap-x-6">
                  {navigationMenu.length > 1 && (
                    <>
                      <CtaWrapper
                        page={ navigationMenu[navigationMenu.length - 2]?.pageUrl && `/${
                          navigationMenu[navigationMenu.length - 2]?.pageUrl
                        }`}
                        url={navigationMenu[navigationMenu.length - 2]?.url}
                        classNames="aaco-cta--invert aaco-cta__primary-filled"
                        onClick={(e) => {
                          handleWhereToBuy(e, {
                            link_url: navigationMenu[navigationMenu.length - 2]?.pageUrl || navigationMenu[navigationMenu.length - 2]?.url,
                            link_text: navigationMenu[navigationMenu.length - 2]?.name,
                            link_classes: e.target.classList.value,
                            lang_country: locale
                          })
                        }}
                      >
                        <Text tag="button">
                          {navigationMenu[navigationMenu.length - 2]?.name}
                        </Text>
                      </CtaWrapper>
                      <CtaWrapper
                        page={ navigationMenu[navigationMenu.length - 1]?.pageUrl && `/${
                          navigationMenu[navigationMenu.length - 1]?.pageUrl
                        }`}
                        url={navigationMenu[navigationMenu.length - 1]?.url}
                        classNames="aaco-cta--invert aaco-cta__primary-line"
                        onClick={(e) => {
                          handleSignUpCta(e, {
                            link_url: navigationMenu[navigationMenu.length - 1]?.pageUrl || navigationMenu[navigationMenu.length - 1]?.url,
                            link_text: navigationMenu[navigationMenu.length - 1]?.name,
                            link_classes: e.target.classList.value,
                            lang_country: locale
                          })
                        }}
                      >
                        <Text tag="button">
                          {navigationMenu[navigationMenu.length - 1]?.name}
                        </Text>
                      </CtaWrapper>
                    </>
                  )}
                  {/* <div
                    role={'button'}
                    onClick={openSearch}
                    className="hidden lg:block"
                  >
                    <Icon
                      name="search"
                      height={18}
                      width={18}
                      className={`text-natural-cream translate-y-[1.5px]`}
                    />
                  </div> */}
                </div>
              </div>
            </div>
          </nav>
          <div
            className={`${
              navigationIsOpen ? 'block' : 'hidden'
            } lg:hidden aaco-mobile-nav absolute origin-top w-full h-full bg-progressive-blue flex flex-col border-t overflow-scroll`}
          >
            <div className="flex flex-col w-full mb-auto">
              {/* <div
                role={'button'}
                onClick={openSearch}
                className="flex gap-x-[15px] items-center h-[55px] px-[30px] shrink-0"
              >
                <Icon
                  name="search"
                  height={18}
                  width={18}
                  className={`w-[18px] h-[18px] text-natural-cream translate-y-[1px]`}
                />
                <Text tag={'body'} style="text-natural-cream">
                  {isKorean ? '검색하기' : 'Search'}
                </Text>
              </div> */}
              <NavigationWithSubMenu
                entries={entries}
                navigationMenu={navigationMenu}
                closeNavigation={closeNavigation}
                setShowCta={setShowCta}
                screen={'mobile'}
                style={`flex flex-col`}
              />
            </div>
            {showCta && (
              <div className="flex flex-col justify-end items-start w-full px-[30px] py-[30px]">
                {navigationMenu.length > 1 && (
                  <div className="flex flex-row items-center gap-6">
                    <CtaWrapper
                      page={ navigationMenu[navigationMenu.length - 2]?.pageUrl && `/${
                        navigationMenu[navigationMenu.length - 2]?.pageUrl
                      }`}
                      url={navigationMenu[navigationMenu.length - 2]?.url}
                      classNames="aaco-cta--invert aaco-cta__primary-filled"
                      onClick={(e) => {
                        handleWhereToBuy(e, {
                          link_url: navigationMenu[navigationMenu.length - 2]?.pageUrl || navigationMenu[navigationMenu.length - 2]?.url,
                          link_text: navigationMenu[navigationMenu.length - 2]?.name,
                          link_classes: e.target.classList.value,
                          lang_country: locale
                        })
                      }}
                    >
                      <Text tag="button">
                        {navigationMenu[navigationMenu.length - 2].name}
                      </Text>
                    </CtaWrapper>
                    <CtaWrapper
                      page={ navigationMenu[navigationMenu.length - 1]?.pageUrl && `/${
                        navigationMenu[navigationMenu.length - 1]?.pageUrl
                      }`}
                      url={navigationMenu[navigationMenu.length - 1]?.url}
                      classNames="aaco-cta--invert aaco-cta__primary-line"
                      onClick={(e) => {
                        handleSignUpCta(e, {
                          link_url: navigationMenu[navigationMenu.length - 1]?.pageUrl || navigationMenu[navigationMenu.length - 1]?.url,
                          link_text: navigationMenu[navigationMenu.length - 1]?.name,
                          link_classes: e.target.classList.value,
                          lang_country: locale
                        })
                      }}
                    >
                      <Text tag="button">
                        {navigationMenu[navigationMenu.length - 1].name}
                      </Text>
                    </CtaWrapper>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
        {/* <Search
          open={searchIsOpen}
          closeSearch={() => {
            setSearchIsOpen(false);
          }}
          closeNavigation={() => {
            setSearchIsOpen(false);
            setNavigationIsOpen(false);
          }}
          tagGroupsWithTags={fields?.tagGroupsWithTags}
        /> */}
      </div>
      {hasBreadcrumbs && (
        <div className="flex flex-row gap-[4px] bg-natural-cream p-5 lg:px-[63px] lg:py-[23px]">
          <div className="hidden lg:flex flex-row gap-[4px] items-center">
            <CtaWrapper
              page={"home"}
              onClick={(e) =>
                handlePageBreadcrumbs(e, {
                  animation: "hover:underline",
                  link_url: "/home",
                  link_text: "Home",
                  link_classes: e.target.classList.value,
                  lang_country: locale,
                })
              }
              classNames={"aaco-underline"}
              animation="hover:underline"
            >
              <Text tag="body" style="text-progressive-blue capitalize">
                Home
              </Text>
            </CtaWrapper>
            <Icon name="chevron-right" height={10} width={10} className={"text-progressive-blue translate-y-[1.5px]"} />
          </div>
          {breadcrumbs && breadcrumbs.map((item, index) => {
            const isLast = index === breadcrumbs.length - 1;

            return (
              <div key={index} className="hidden lg:flex flex-row gap-[4px] items-center">
                {isLast ? (
                  <Text tag="body" style="text-progressive-blue capitalize">
                    {item.replaceAll("-", " ")}
                  </Text>
                ) : (
                  <CtaWrapper
                    page={item}
                    onClick={(e) =>
                      handlePageBreadcrumbs(e, {
                        animation: "hover:underline",
                        link_url: `/${item}`,
                        link_text: item,
                        link_classes: e.target.classList.value,
                        lang_country: locale,
                      })
                    }
                    classNames={"aaco-underline"}
                    animation="hover:underline"
                  >
                    <Text tag="body" style="text-progressive-blue capitalize">
                      {item.replaceAll("-", " ")}
                    </Text>
                  </CtaWrapper>
                )}
                {!isLast && (
                  <Icon name="chevron-right" height={10} width={10} className={"text-progressive-blue translate-y-[1.5px]"} />
                )}
              </div>
            )
          })}
          {breadcrumbs.length > 1 ? (
            <>
              <div className="flex lg:hidden flex-row gap-[4px] items-center">
              <CtaWrapper
                page={breadcrumbs[breadcrumbs.length - 2]}
                onClick={(e) =>
                  handlePageBreadcrumbs(e, {
                    animation: "hover:underline",
                    link_url: `/${breadcrumbs[breadcrumbs?.length - 2]}`,
                    link_text: item,
                    link_classes: e.target.classList.value,
                    lang_country: locale,
                  })
                }
                classNames={"aaco-underline"}
                animation="hover:underline"
              >
                <Text tag="body" style="text-progressive-blue capitalize">
                  {breadcrumbs[breadcrumbs.length - 2]?.replaceAll("-", " ")}
                </Text>
              </CtaWrapper>
              <Icon name="chevron-right" height={10} width={10} className={"text-progressive-blue translate-y-[1.5px]"} />
            </div>
            <div className="flex lg:hidden flex-row gap-[4px] items-center">
              <Text tag="body" style="text-progressive-blue capitalize">
                {breadcrumbs[breadcrumbs.length - 1]?.replaceAll("-", " ")}
              </Text>
            </div>
            </>
          ) : (
            <>
              <div className="flex lg:hidden flex-row gap-[4px] items-center">
                <CtaWrapper
                  page={"home"}
                  onClick={(e) =>
                    handlePageBreadcrumbs(e, {
                      animation: "hover:underline",
                      link_url: "/home",
                      link_text: item,
                      link_classes: e.target.classList.value,
                      lang_country: locale,
                    })
                  }
                  classNames={"aaco-underline"}
                  animation="hover:underline"
                >
                  <Text tag="body" style="text-progressive-blue capitalize">
                    Home
                  </Text>
                </CtaWrapper>
                <Icon name="chevron-right" height={10} width={10} className={"text-progressive-blue translate-y-[1.5px]"} />
              </div>
              <div className="flex lg:hidden flex-row gap-[4px] items-center">
                <Text tag="body" style="text-progressive-blue capitalize">
                  {breadcrumbs[0]?.replaceAll("-", " ")}
                </Text>
              </div>
            </>
          )}
        </div>
      )}
    </>
  );
}

// @TODO: define real props for the Navigation based on it requirements
NavigationSticky.propTypes = {
  entries: PropTypes.array,
  fields: PropTypes.object,
  hasBackground: PropTypes.bool,
  tagGroupsWithTags: PropTypes.array,
  slug: PropTypes.string,
};

export default NavigationSticky;
